"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.project.exceeded': 'Limite progetti raggiunto. Aggiorna il tuo piano per creare più progetti.',
    'limits.project.limitReached': 'Limite progetti: {limit} (aggiorna per crearne di più)',
};
